import KColors from './colors';
import KDims from './dimensions';
import KFontWeights from './fonts';
import KPaging from './paging';

export const APP_NAME = 'ProntoClass';

export { KFontWeights, KColors, KPaging, KDims };
